import { useEffect } from "react";
import { createWakeLockManager } from "@/utils/wake-lock-manager";

/**
 * Keep the screen awake while the visit page is mounted.
 *
 * Mounted at PAGE level (not gated on rtcJoined): participants can sit in the
 * waiting room before the host starts the visit — the screen must not sleep
 * during that lobby phase either (a sleeping tablet cuts the tab's network,
 * see wake-lock-manager.ts for the incident chain).
 */
export default function useWakeLock(active: boolean = true): void {
  useEffect(() => {
    if (!active) return;
    const manager = createWakeLockManager();
    const onVisibilityChange = () => manager.handleVisibilityChange();
    manager.start();
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      void manager.stop();
    };
  }, [active]);
}
